export default __webpack_public_path__ + "static/media/CHART.14c38fb6.png";